module.exports = __webpack_public_path__ + "img/no-image-icon.7c2534d3.png";